import { render, staticRenderFns } from "./SaveMarketGroupButton.vue?vue&type=template&id=0b0c9d4e&scoped=true&"
import script from "./SaveMarketGroupButton.vue?vue&type=script&lang=js&"
export * from "./SaveMarketGroupButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c9d4e",
  null
  
)

export default component.exports